import { Injectable } from '@angular/core';
import { SharedService } from '../shared/shared.service';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, CanActivateChild, Data } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class AuthguardService {

  ngOnInit(): void {
    this.sharedService.screenInfoMessage.subscribe(info => this.screenInfo = info);
  }
  screenInfo: object;
  constructor(private sharedService: SharedService, private router: Router, private titleService: Title) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if ((this.sharedService.getAccessToken() == null || this.sharedService.getAccessToken().length == 0) && (state.url != "/recoverpwd" && state.url != "/pwdreset" && state.url.indexOf("/incentive_report")<0)) {
      this.router.navigate(['/login']);
      return false;
    }
    this.sharedService.updateRouteInformation(route.data);
    return true;
  }

}
